import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Autoreplace } from 'src/app/utils/interfaces/new/autoreplace.interface';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class AutoreplaceService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };
  private uri = environment.basePath + "/autoreplace/replace";

  constructor(
    private http: HttpClient,
    private _snack: SnackbarService
  ) { }

  async findByName(name: string): Promise<Autoreplace[]> {
    try {
      const res = await this.http.get(this.uri + "/" + name, this.httpOptions).toPromise();
      const autoRepList = res.body as Autoreplace[];
      return autoRepList;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async findPatientListByName(name: string, patientId: string): Promise<Autoreplace[]> {
    try {
      const res = await this.http.get(this.uri + "/" + name + "/patient/" + patientId, this.httpOptions).toPromise();
      const autoRepList = res.body as Autoreplace[];
      return autoRepList;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async findOnePatientByNameAndKey(name: string, key: string, patientId: string): Promise<Autoreplace> {
    try {
      const keyURI = encodeURIComponent(key);
      const res = await this.http.get(this.uri + "/" + name + "/" + keyURI + "/patient/" + patientId, this.httpOptions).toPromise();
      const autoRep = res.body as Autoreplace;
      return autoRep;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async findOneByNameAndKey(name: string, key: string): Promise<Autoreplace> {
    try {
      const res = await this.http.get(this.uri + "/" + name + "/" + key, this.httpOptions).toPromise();
      const autoRep = res.body as Autoreplace;
      return autoRep;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
